import { useEffect } from 'react';
import { EnabledRepositoriesStatus, Step } from 'shared/InstallationDialog';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { renderTranslations, spawn } from 'utils/translations';
import { ENABLE_QODO_TRANSLATION_KEY } from '../consts';
import { useGitlabInstallation } from '../gitlabInstallationContext';

export const EnableQodo = () => {
  const {
    currentStepIndex,
    setCurrentStepAsFurthestStepReached,
    setEarliestStepAvailable,
  } = useMultiStepDialog();
  const { totalSucceededCount, authType } = useGitlabInstallation();

  const spawnStep = spawn(ENABLE_QODO_TRANSLATION_KEY);

  // GAT connects a whole group, so `totalSucceededCount` is a group count — use
  // group-oriented copy. PAT/OAuth report a count via the counted message.
  const enabledMessage =
    authType === 'gat'
      ? spawnStep('enabled-message-group')
      : spawnStep('enabled-message', { count: totalSucceededCount });

  useEffect(() => {
    setCurrentStepAsFurthestStepReached();
    setEarliestStepAvailable(currentStepIndex);
  }, [
    currentStepIndex,
    setCurrentStepAsFurthestStepReached,
    setEarliestStepAvailable,
  ]);

  return (
    <Step
      title={spawnStep('title')}
      description={renderTranslations(
        `${ENABLE_QODO_TRANSLATION_KEY}.description`,
      )}
    >
      <div className="flex flex-col gap-8">
        <EnabledRepositoriesStatus
          title={enabledMessage}
          description={spawnStep('enabled-description')}
        />
      </div>
    </Step>
  );
};
